import {
  notify
} from "./chunk-DL5QNKBI.js";
import {
  PAGE_STATUS
} from "./chunk-OSVSI4BW.js";
import {
  __publicField
} from "./chunk-JCO6WRHX.js";

// src/pages/Roles/RoleViewModel/RoleListViewModel.ts
import { makeAutoObservable, runInAction } from "mobx";
import { ORGANISATION_ROLE_FIELD } from "aesirx-lib";
import moment from "moment";
var RoleListViewModel = class {
  constructor(roleStore) {
    __publicField(this, "roleStore");
    __publicField(this, "formStatus", PAGE_STATUS.READY);
    __publicField(this, "roleListViewModel", {});
    __publicField(this, "items", []);
    __publicField(this, "filter", {});
    __publicField(this, "successResponse", {
      state: false,
      content_id: "",
      listPublishStatus: [],
      1: [],
      filters: {
        "list[limit]": 10
      },
      listRoles: [],
      pagination: null,
      listRolesWithoutPagination: []
    });
    __publicField(this, "setForm", (roleListViewModel) => {
      this.roleListViewModel = roleListViewModel;
    });
    __publicField(this, "initializeData", async () => {
      runInAction(() => {
        this.successResponse.state = false;
      });
      const data = await this.roleStore.getList(this.successResponse.filters);
      runInAction(() => {
        if (!data?.error) {
          this.onSuccessHandler(data?.response, "");
        } else {
          this.onErrorHandler(data?.response);
        }
      });
    });
    __publicField(this, "initializeAllData", async () => {
      runInAction(() => {
        this.successResponse.state = false;
      });
      const data = await this.roleStore.getListWithoutPagination(this.filter);
      runInAction(() => {
        if (!data?.error) {
          this.callbackOnSuccessGetRolesHandler(data?.response);
        } else {
          this.onErrorHandler(data?.response);
        }
        this.successResponse.state = true;
      });
    });
    __publicField(this, "getListByFilter", async (key, value) => {
      value ? this.successResponse.filters[key] = value : delete this.successResponse.filters[key];
      if (key != "list[start]" && key != "list[limit]") {
        delete this.successResponse.filters["list[start]"];
      } else {
        if (key == "list[limit]" && value * this.successResponse.pagination.page >= this.successResponse.pagination.totalItems) {
          this.successResponse.filters["list[start]"] = Math.ceil(this.successResponse.pagination.totalItems / value - 1) * value;
        } else if (key == "list[limit]" && value * this.successResponse.pagination.page < this.successResponse.pagination.totalItems) {
          this.successResponse.filters["list[start]"] = (this.successResponse.pagination.page - 1) * value;
        }
      }
      const data = await this.roleStore.getList(this.successResponse.filters);
      runInAction(() => {
        if (!data?.error) {
          this.onSuccessHandler(data?.response, "");
        } else {
          this.onErrorHandler(data?.response);
        }
        this.successResponse.state = true;
      });
    });
    __publicField(this, "onSuccessHandler", (result, message) => {
      if (result && message) {
        notify(message, "success");
      }
      if (result?.listItems) {
        this.successResponse.listRoles = this.transform(result?.listItems);
        this.successResponse.pagination = result?.pagination;
        this.items = result?.listItems;
        this.successResponse.state = true;
      }
      if (result?.listPublishStatus) {
        this.successResponse.listPublishStatus = result?.listPublishStatus;
      }
    });
    __publicField(this, "onErrorHandler", (error) => {
      error._messages[0]?.message ? notify(error._messages[0]?.message, "error") : error.message && notify(error.message, "error");
      this.successResponse.state = false;
      this.successResponse.content_id = error.result;
      this.formStatus = PAGE_STATUS.READY;
    });
    __publicField(this, "transform", (data) => {
      return data.map((o) => {
        const date = moment(o[ORGANISATION_ROLE_FIELD.MODIFIED_TIME]).format("DD MMM, YYYY");
        return {
          role: {
            id: o[ORGANISATION_ROLE_FIELD.ID],
            name: o[ORGANISATION_ROLE_FIELD.ROLE_NAME]
          },
          organisation: o[ORGANISATION_ROLE_FIELD.ORGANISATION],
          lastModified: {
            status: o[ORGANISATION_ROLE_FIELD.PUBLISHED],
            dateTime: date ?? "",
            author: o[ORGANISATION_ROLE_FIELD.CREATED_USER_NAME]
          },
          published: {
            state: o[ORGANISATION_ROLE_FIELD.PUBLISHED],
            id: o[ORGANISATION_ROLE_FIELD.ID]
          }
        };
      });
    });
    __publicField(this, "deleteRoles", async (arr) => {
      const data = await this.roleStore.delete(arr);
      runInAction(async () => {
        if (!data?.error) {
          await this.initializeData();
          this.onSuccessHandler(data?.response, "Deleted successfully");
        } else {
          this.onErrorHandler(data?.response);
        }
        this.successResponse.state = true;
      });
    });
    __publicField(this, "setPublished", async ({ id, name }, state = 0) => {
      const data = await this.roleStore.update({
        id: id.toString(),
        role_name: name,
        published: state.toString()
      });
      runInAction(async () => {
        if (!data?.error) {
          await this.initializeData();
          this.onSuccessHandler(data?.response, "Updated successfully");
        } else {
          this.onErrorHandler(data?.response);
        }
      });
    });
    __publicField(this, "isLoading", () => {
      runInAction(() => {
        this.successResponse.state = false;
      });
    });
    __publicField(this, "callbackOnSuccessGetRolesHandler", (result) => {
      this.successResponse.listRolesWithoutPagination = result?.listItems?.map((o) => {
        let dash = "";
        for (let index = 1; index < o.level; index++) {
          dash += "- ";
        }
        return {
          value: o?.id,
          label: `${dash}${o[ORGANISATION_ROLE_FIELD.ROLE_NAME]}`
        };
      });
    });
    makeAutoObservable(this);
    this.roleStore = roleStore;
  }
};
var RoleListViewModel_default = RoleListViewModel;

export {
  RoleListViewModel_default
};
/*
 * @copyright   Copyright (C) 2022 AesirX. All rights reserved.
 * @license     GNU General Public License version 3, see LICENSE.
 */
